import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {

  openRightPanel: Subject<any> = new Subject<any>();
  closeRightPanel: Subject<void> = new Subject<void>();

}
